import React, { useEffect, useState } from 'react';
import snakecaseKeys from 'snakecase-keys';
import { useDispatch } from 'react-redux';
import DataLoadForm from './DataLoadForm';
import dataLoad from './dataload';
import { createDataLoadRequest } from '../../requests/dataLoads';
import { sendAlert } from '../../actions/utils';
import { showMonthOfProcessActiveRequest } from '../../requests/monthOfProcesses';
import { downloadFile } from '../../services/utils';

const DataLoadIndex = () => {
  const dispatch = useDispatch();
  const [moreData, setMoreData] = useState(false);
  const [listEmployees, setListEmployees] = useState([]);
  const [activeMonth, setActiveMonth] = useState({});

  const handleSuccessAction = (message, resetForm, setFieldValue) => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
    setFieldValue('dataLoad[employeeIds]', []);
    resetForm();
  };

  const handleFailureRequest = error => {
    dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
  };

  const handleCreate = (values, setSubmitting, resetForm, setFieldValue) => {
    const params = snakecaseKeys(values);
    createDataLoadRequest({
      dispatch,
      params,
      successCallback: response => {
        downloadFile(response);
        handleSuccessAction('Cargas de datos creadas correctamente', resetForm, setFieldValue);
      },
      failureCallback: handleFailureRequest,
      callback: () => setSubmitting(false)
    });
  };

  const handleShowMonthOfProcess = () => {
    showMonthOfProcessActiveRequest({
      dispatch,
      successCallback: response => setActiveMonth(response.data || '')
    });
  };

  useEffect(handleShowMonthOfProcess, []);

  return (
    <>
      <DataLoadForm
        dataLoad={dataLoad}
        action="new"
        formRequest={handleCreate}
        setListEmployees={setListEmployees}
        listEmployees={listEmployees}
        activeMonth={activeMonth}
        moreData={moreData}
      />
    </>
  );
};

export default DataLoadIndex;
